/**
 * Configurador de piscinas — estado, etapas, localStorage, WhatsApp.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'viniltec_pool_configurator_state_v2';

  var DEFAULT_STATE = {
    ambiente: '',
    modelo: '',
    vinilHandle: '',
    vinilTitulo: '',
    vinilImagemUrl: '',
    vinilProductUrl: '',
    medidaLargura: '',
    medidaComprimento: '',
    medidaObs: '',
    adicionais: [],
    personalizada: false,
    formatoCustom: '',
    largura: '',
    comprimento: '',
    estilo: '',
    descricao: '',
    referencia: '',
    nome: '',
    telefone: '',
    email: '',
  };

  var MODEL_LABELS = {
    retangular: 'Piscina Retangular',
    prainha: 'Com Prainha',
    compacta: 'Compacta',
    oval: 'Oval',
    personalizada: 'Projeto Personalizado',
  };

  var AMBIENTE_LABELS = {
    casa: 'Casa',
    apartamento: 'Apartamento',
    chacara: 'Chácara',
    fazenda: 'Fazenda',
  };

  var VINYL_LAYER_MODELS = ['retangular', 'prainha', 'compacta', 'oval'];

  var VINIL_PAGE_SIZE = 8;

  var state = Object.assign({}, DEFAULT_STATE);
  var vinilCarouselPage = 0;
  var stepIndex = 0;
  var assetMap = { personalizada: '', bases: {} };
  var saveTimer = null;
  var defaultPreviewSrc = '';

  /** URLs protocol-relative do Liquid (//cdn...) → https para compatibilidade com theme dev e ferramentas. */
  function toAbsoluteAssetUrl(url) {
    if (!url || typeof url !== 'string') return url;
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  function applyPreviewSrc(img, url) {
    url = toAbsoluteAssetUrl(url);
    if (!url) return;
    if (img.src === url) {
      img.classList.remove('pool-configurator__preview-img--loading');
      return;
    }
    function finish() {
      img.classList.remove('pool-configurator__preview-img--loading');
    }
    img.classList.add('pool-configurator__preview-img--loading');
    img.addEventListener('load', finish, { once: true });
    img.addEventListener('error', finish, { once: true });
    img.src = url;
  }

  function cssUrl(value) {
    if (!value) return '';
    return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function $all(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function getRoot() {
    return document.getElementById('pool-configurator-root');
  }

  function getSteps() {
    var steps = ['ambiente', 'modelos'];
    if (!state.personalizada) steps.push('vinil');
    steps.push('tamanho', 'adicionais');
    if (state.personalizada) steps.push('personalizada');
    steps.push('dados');
    return steps;
  }

  function normalizeWaDigits(raw) {
    var d = String(raw || '').replace(/\D/g, '');
    if (!d.length) return '';
    if (d.indexOf('55') !== 0) d = '55' + d;
    return d;
  }

  function loadAssets() {
    var el = document.getElementById('pool-configurator-assets');
    if (!el || !el.textContent) return;
    try {
      assetMap = JSON.parse(el.textContent);
      if (!assetMap.bases) assetMap.bases = {};
    } catch (e) {
      assetMap = { personalizada: '', bases: {} };
    }
  }

  function scheduleSave() {
    if (saveTimer) clearTimeout(saveTimer);
    saveTimer = setTimeout(persist, 280);
  }

  function persist() {
    try {
      var payload = { state: state, stepIndex: stepIndex };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {
      /* ignore */
    }
  }

  function hydrate() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var payload = JSON.parse(raw);
      if (payload.state && typeof payload.state === 'object') {
        state = Object.assign({}, DEFAULT_STATE, payload.state);
        if (!Array.isArray(state.adicionais)) state.adicionais = [];
      }
      if (typeof payload.stepIndex === 'number' && payload.stepIndex >= 0) {
        stepIndex = payload.stepIndex;
      }
    } catch (e) {
      /* ignore */
    }
    clampStepIndex();
    syncVinilPageFromSelection();
  }

  function clampStepIndex() {
    var steps = getSteps();
    if (stepIndex >= steps.length) stepIndex = Math.max(0, steps.length - 1);
  }

  function getVinilCards() {
    return $all('#pool-cfg-vinil-grid .pool-cfg-vinil-card');
  }

  function syncVinilPageFromSelection() {
    if (!state.vinilHandle) return;
    var cards = getVinilCards();
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].getAttribute('data-vinil-handle') === state.vinilHandle) {
        var p = parseInt(cards[i].getAttribute('data-vinil-page') || '0', 10);
        if (!isNaN(p)) vinilCarouselPage = p;
        break;
      }
    }
  }

  function renderVinilCarousel() {
    var cards = getVinilCards();
    var toolbar = document.getElementById('pool-cfg-vinil-toolbar');
    var meta = document.getElementById('pool-cfg-vinil-page-meta');
    var prevBtn = document.querySelector('#pool-step-vinil [data-vinil-nav="prev"]');
    var nextBtn = document.querySelector('#pool-step-vinil [data-vinil-nav="next"]');
    if (!cards.length) return;
    var totalPages = Math.max(1, Math.ceil(cards.length / VINIL_PAGE_SIZE));
    if (vinilCarouselPage > totalPages - 1) vinilCarouselPage = Math.max(0, totalPages - 1);
    if (vinilCarouselPage < 0) vinilCarouselPage = 0;
    if (cards.length <= VINIL_PAGE_SIZE) {
      cards.forEach(function (c) {
        c.hidden = false;
        c.style.display = '';
        c.setAttribute('aria-hidden', 'false');
      });
      if (toolbar) toolbar.hidden = true;
      if (meta) meta.textContent = cards.length + ' opções';
      return;
    }
    if (toolbar) toolbar.hidden = false;
    cards.forEach(function (card) {
      var p = parseInt(card.getAttribute('data-vinil-page') || '0', 10);
      var show = p === vinilCarouselPage;
      card.hidden = !show;
      card.style.display = show ? '' : 'none';
      card.setAttribute('aria-hidden', show ? 'false' : 'true');
    });
    var start = vinilCarouselPage * VINIL_PAGE_SIZE + 1;
    var end = Math.min(cards.length, (vinilCarouselPage + 1) * VINIL_PAGE_SIZE);
    if (meta) {
      meta.textContent =
        'Página ' +
        (vinilCarouselPage + 1) +
        ' de ' +
        totalPages +
        ' · itens ' +
        start +
        '–' +
        end +
        ' de ' +
        cards.length;
    }
    if (prevBtn) {
      prevBtn.disabled = vinilCarouselPage <= 0;
      prevBtn.setAttribute('aria-disabled', vinilCarouselPage <= 0 ? 'true' : 'false');
    }
    if (nextBtn) {
      nextBtn.disabled = vinilCarouselPage >= totalPages - 1;
      nextBtn.setAttribute('aria-disabled', vinilCarouselPage >= totalPages - 1 ? 'true' : 'false');
    }
  }

  function updateVinylSwatch() {
    var wrap = document.getElementById('pool-cfg-vinil-swatch');
    var im = document.getElementById('pool-cfg-vinil-swatch-img');
    if (!wrap || !im) return;
    if (!state.personalizada && state.vinilImagemUrl) {
      im.src = toAbsoluteAssetUrl(state.vinilImagemUrl);
      im.alt = state.vinilTitulo ? 'Amostra do vinil: ' + state.vinilTitulo : 'Amostra do vinil';
      wrap.hidden = false;
      wrap.setAttribute('aria-hidden', 'false');
    } else {
      im.removeAttribute('src');
      im.alt = '';
      wrap.hidden = true;
      wrap.setAttribute('aria-hidden', 'true');
    }
  }

  function updateVinylLayer() {
    var layer = document.getElementById('pool-cfg-vinil-layer');
    if (layer) {
      VINYL_LAYER_MODELS.forEach(function (m) {
        layer.classList.remove('pool-configurator__vinil-layer--' + m);
      });
      if (state.modelo && VINYL_LAYER_MODELS.indexOf(state.modelo) !== -1) {
        layer.classList.add('pool-configurator__vinil-layer--' + state.modelo);
      }
      if (!state.personalizada && state.vinilImagemUrl) {
        layer.style.backgroundImage = 'url("' + cssUrl(toAbsoluteAssetUrl(state.vinilImagemUrl)) + '")';
        layer.classList.add('is-visible');
      } else {
        layer.style.backgroundImage = '';
        layer.classList.remove('is-visible');
      }
    }
    updateVinylSwatch();
  }

  function updatePreviewImage() {
    var img = document.getElementById('pool-cfg-preview-img');
    if (!img) return;
    var url = '';
    if (state.personalizada && assetMap.personalizada) {
      url = assetMap.personalizada;
    } else if (state.modelo && !state.personalizada) {
      url = assetMap.bases[state.modelo] || '';
    }
    if (!url && defaultPreviewSrc) url = defaultPreviewSrc;
    if (url) {
      if (state.personalizada) {
        img.alt = 'Pré-visualização projeto personalizado';
      } else if (state.modelo) {
        img.alt =
          'Pré-visualização ' + (MODEL_LABELS[state.modelo] || state.modelo);
      } else {
        img.alt = 'Pré-visualização da piscina';
      }
      applyPreviewSrc(img, url);
    }
    updateVinylLayer();
  }

  function formatMedidasSummary() {
    var l = (state.medidaLargura || '').trim();
    var c = (state.medidaComprimento || '').trim();
    if (!l && !c) return '—';
    var line = (l || '—') + ' × ' + (c || '—') + ' m';
    var obs = (state.medidaObs || '').trim();
    if (obs) line += ' (' + obs + ')';
    return line;
  }

  function renderSummary() {
    var amb =
      state.ambiente && AMBIENTE_LABELS[state.ambiente]
        ? AMBIENTE_LABELS[state.ambiente]
        : state.ambiente
          ? state.ambiente
          : '—';
    $all('[data-summary="ambiente"]').forEach(function (dd) {
      dd.textContent = amb;
    });

    var modeloText =
      state.modelo && MODEL_LABELS[state.modelo]
        ? MODEL_LABELS[state.modelo]
        : state.modelo
          ? state.modelo
          : '—';
    $all('[data-summary="modelo"]').forEach(function (dd) {
      dd.textContent = modeloText;
    });

    $all('[data-summary="tamanho"]').forEach(function (dd) {
      dd.textContent = formatMedidasSummary();
    });

    var vinilText = '—';
    if (state.personalizada) {
      vinilText = 'Projeto personalizado';
    } else if (state.vinilTitulo) {
      vinilText = state.vinilTitulo;
    }
    $all('[data-summary="vinil"]').forEach(function (dd) {
      dd.textContent = vinilText;
    });

    var adic = state.adicionais && state.adicionais.length ? state.adicionais.join(', ') : 'Nenhum';
    $all('[data-summary="adicionais"]').forEach(function (dd) {
      dd.textContent = adic;
    });
  }

  function renderProgress() {
    var steps = getSteps();
    clampStepIndex();
    var fill = document.getElementById('pool-cfg-progress-fill');
    var label = document.getElementById('pool-cfg-progress-label');
    var n = stepIndex + 1;
    var total = steps.length;
    var pct = total ? (n / total) * 100 : 0;
    if (fill) fill.style.width = pct + '%';
    if (label) label.textContent = 'Passo ' + n + ' de ' + total;
  }

  function updateStepVisibility() {
    var steps = getSteps();
    clampStepIndex();
    var current = steps[stepIndex];
    $all('.pool-cfg-step').forEach(function (el) {
      var id = el.getAttribute('data-step');
      var isCurrent = id === current;
      el.classList.toggle('pool-cfg-step--hidden', !isCurrent);
      el.hidden = !isCurrent;
      el.setAttribute('aria-hidden', isCurrent ? 'false' : 'true');
    });
  }

  function syncSelectionClasses() {
    $all('.pool-cfg-ambiente-card').forEach(function (btn) {
      var a = btn.getAttribute('data-ambiente');
      var sel = a === state.ambiente;
      btn.classList.toggle('is-selected', sel);
      btn.setAttribute('aria-pressed', sel ? 'true' : 'false');
    });
    $all('.pool-cfg-card').forEach(function (btn) {
      var m = btn.getAttribute('data-model');
      var sel = m === state.modelo;
      btn.classList.toggle('is-selected', sel);
      btn.setAttribute('aria-pressed', sel ? 'true' : 'false');
    });
    $all('.pool-cfg-vinil-card').forEach(function (btn) {
      var h = btn.getAttribute('data-vinil-handle');
      var sel = h === state.vinilHandle;
      btn.classList.toggle('is-selected', sel);
      btn.setAttribute('aria-pressed', sel ? 'true' : 'false');
    });
    $all('[data-adicional]').forEach(function (inp) {
      var v = inp.value;
      inp.checked = state.adicionais.indexOf(v) !== -1;
    });
  }

  function readMedidasFields() {
    var l = document.getElementById('pool-cfg-medida-largura');
    var c = document.getElementById('pool-cfg-medida-comprimento');
    var o = document.getElementById('pool-cfg-medida-obs');
    state.medidaLargura = l ? l.value.trim() : '';
    state.medidaComprimento = c ? c.value.trim() : '';
    state.medidaObs = o ? o.value.trim() : '';
  }

  function syncFormFieldsFromState() {
    var ml = document.getElementById('pool-cfg-medida-largura');
    var mc = document.getElementById('pool-cfg-medida-comprimento');
    var mo = document.getElementById('pool-cfg-medida-obs');
    if (ml) ml.value = state.medidaLargura || '';
    if (mc) mc.value = state.medidaComprimento || '';
    if (mo) mo.value = state.medidaObs || '';

    var fmt = document.getElementById('pool-cfg-formato');
    var lar = document.getElementById('pool-cfg-largura');
    var comp = document.getElementById('pool-cfg-comprimento');
    var est = document.getElementById('pool-cfg-estilo');
    var desc = document.getElementById('pool-cfg-descricao');
    var ref = document.getElementById('pool-cfg-referencia');
    var nom = document.getElementById('pool-cfg-nome');
    var tel = document.getElementById('pool-cfg-telefone');
    var em = document.getElementById('pool-cfg-email');
    if (fmt) fmt.value = state.formatoCustom || '';
    if (lar) lar.value = state.largura || '';
    if (comp) comp.value = state.comprimento || '';
    if (est) est.value = state.estilo || '';
    if (desc) desc.value = state.descricao || '';
    if (ref) ref.value = state.referencia || '';
    if (nom) nom.value = state.nome || '';
    if (tel) tel.value = state.telefone || '';
    if (em) em.value = state.email || '';
    updateDescCounter();
  }

  function readPersonalFields() {
    var fmt = document.getElementById('pool-cfg-formato');
    var lar = document.getElementById('pool-cfg-largura');
    var comp = document.getElementById('pool-cfg-comprimento');
    var est = document.getElementById('pool-cfg-estilo');
    var desc = document.getElementById('pool-cfg-descricao');
    var ref = document.getElementById('pool-cfg-referencia');
    state.formatoCustom = fmt ? fmt.value.trim() : '';
    state.largura = lar ? lar.value.trim() : '';
    state.comprimento = comp ? comp.value.trim() : '';
    state.estilo = est ? est.value.trim() : '';
    state.descricao = desc ? desc.value.trim() : '';
    state.referencia = ref ? ref.value.trim() : '';
  }

  function readContactFields() {
    var nom = document.getElementById('pool-cfg-nome');
    var tel = document.getElementById('pool-cfg-telefone');
    var em = document.getElementById('pool-cfg-email');
    state.nome = nom ? nom.value.trim() : '';
    state.telefone = tel ? tel.value.trim() : '';
    state.email = em ? em.value.trim() : '';
  }

  function updateDescCounter() {
    var desc = document.getElementById('pool-cfg-descricao');
    var hint = document.getElementById('pool-cfg-desc-chars');
    if (desc && hint) hint.textContent = (desc.value || '').length + '/300';
  }

  function collectAdicionaisFromDom() {
    state.adicionais = $all('[data-adicional]:checked').map(function (i) {
      return i.value;
    });
  }

  function hideError(id) {
    var el = document.getElementById(id);
    if (el) el.hidden = true;
  }

  function showError(id) {
    var el = document.getElementById(id);
    if (el) el.hidden = false;
  }

  function absoluteProductUrl(pathOrUrl) {
    if (!pathOrUrl) return '';
    var s = String(pathOrUrl);
    if (/^https?:\/\//i.test(s)) return s;
    var root = getRoot();
    var shop = root ? root.getAttribute('data-shop-url') : '';
    shop = (shop || '').replace(/\/$/, '');
    if (!shop) return s;
    return shop + (s.indexOf('/') === 0 ? s : '/' + s);
  }

  function buildWhatsAppMessage() {
    var lines = [];
    lines.push('Olá! Vim pelo configurador de piscinas e quero falar com um vendedor.');
    lines.push('');
    lines.push('Resumo do pedido:');
    var loc =
      state.ambiente && AMBIENTE_LABELS[state.ambiente]
        ? AMBIENTE_LABELS[state.ambiente]
        : state.ambiente || '—';
    lines.push('• Local: ' + loc);
    lines.push('• Modelo: ' + (state.modelo ? MODEL_LABELS[state.modelo] || state.modelo : '—'));
    if (state.personalizada) {
      lines.push('• Vinil: Projeto personalizado');
    } else if (state.vinilTitulo) {
      lines.push('• Vinil: ' + state.vinilTitulo);
      var pu = absoluteProductUrl(state.vinilProductUrl);
      if (pu) lines.push('  Link: ' + pu);
    } else {
      lines.push('• Vinil: —');
    }
    lines.push('• Medidas: ' + formatMedidasSummary());
    lines.push(
      '• Adicionais: ' +
        (state.adicionais && state.adicionais.length ? state.adicionais.join(', ') : 'Nenhum')
    );
    if (state.personalizada) {
      lines.push('');
      lines.push('Projeto personalizado:');
      lines.push('• Formato: ' + (state.formatoCustom || '—'));
      lines.push('• Largura: ' + (state.largura || '—'));
      lines.push('• Comprimento: ' + (state.comprimento || '—'));
      lines.push('• Estilo: ' + (state.estilo || '—'));
      lines.push('• Descrição: ' + (state.descricao || '—'));
      if (state.referencia) lines.push('• Referência: ' + state.referencia);
    }
    lines.push('');
    lines.push('Meus dados:');
    lines.push('• Nome: ' + (state.nome || '—'));
    lines.push('• Telefone: ' + (state.telefone || '—'));
    if (state.email) lines.push('• E-mail: ' + state.email);
    return lines.join('\n');
  }

  function openWhatsApp() {
    var root = getRoot();
    if (!root) return;
    readContactFields();
    readPersonalFields();
    readMedidasFields();
    hideError('pool-cfg-err-wa');
    if (!state.nome || !state.telefone) {
      showError('pool-cfg-err-dados');
      hideError('pool-cfg-err-wa');
      return;
    }
    hideError('pool-cfg-err-dados');
    var digits = normalizeWaDigits(root.getAttribute('data-whatsapp-digits'));
    if (!digits) {
      showError('pool-cfg-err-wa');
      return;
    }
    hideError('pool-cfg-err-wa');
    var text = buildWhatsAppMessage();
    var url = 'https://wa.me/' + digits + '?text=' + encodeURIComponent(text);
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  function validateAndAdvanceFrom(key) {
    if (key === 'ambiente') {
      if (!state.ambiente) {
        showError('pool-cfg-err-ambiente');
        return false;
      }
      hideError('pool-cfg-err-ambiente');
      return true;
    }
    if (key === 'modelos') {
      if (!state.modelo) {
        showError('pool-cfg-err-modelos');
        return false;
      }
      hideError('pool-cfg-err-modelos');
      return true;
    }
    if (key === 'vinil') {
      if (state.personalizada) return true;
      var root = getRoot();
      if (root && root.getAttribute('data-vinil-catalog-empty') === 'true') {
        showError('pool-cfg-err-vinil');
        return false;
      }
      if (!$all('.pool-cfg-vinil-card').length) {
        showError('pool-cfg-err-vinil');
        return false;
      }
      if (!state.vinilHandle) {
        showError('pool-cfg-err-vinil');
        return false;
      }
      hideError('pool-cfg-err-vinil');
      return true;
    }
    if (key === 'tamanho') {
      readMedidasFields();
      if (!state.medidaLargura || !state.medidaComprimento) {
        showError('pool-cfg-err-tamanho');
        return false;
      }
      hideError('pool-cfg-err-tamanho');
      return true;
    }
    return true;
  }

  function next() {
    var steps = getSteps();
    var current = steps[stepIndex];
    if (!validateAndAdvanceFrom(current)) return;
    readPersonalFields();
    readContactFields();
    readMedidasFields();
    collectAdicionaisFromDom();
    if (stepIndex < steps.length - 1) {
      stepIndex++;
      renderAll();
      persist();
    }
  }

  function back() {
    if (stepIndex > 0) {
      stepIndex--;
      renderAll();
      persist();
    }
  }

  function renderAll() {
    clampStepIndex();
    syncSelectionClasses();
    syncFormFieldsFromState();
    updateStepVisibility();
    renderProgress();
    renderSummary();
    updatePreviewImage();
    renderVinilCarousel();
    scheduleSave();
  }

  function clearVinil() {
    state.vinilHandle = '';
    state.vinilTitulo = '';
    state.vinilImagemUrl = '';
    state.vinilProductUrl = '';
  }

  function bind() {
    var root = getRoot();
    if (!root) return;

    $all('.pool-cfg-ambiente-card').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.ambiente = btn.getAttribute('data-ambiente') || '';
        syncSelectionClasses();
        renderSummary();
        hideError('pool-cfg-err-ambiente');
        scheduleSave();
      });
    });

    $all('.pool-cfg-card').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var m = btn.getAttribute('data-model');
        state.modelo = m || '';
        state.personalizada = m === 'personalizada';
        if (state.personalizada) {
          clearVinil();
        }
        if (!state.personalizada) {
          state.formatoCustom = '';
          state.largura = '';
          state.comprimento = '';
          state.estilo = '';
          state.descricao = '';
          state.referencia = '';
        }
        syncSelectionClasses();
        renderSummary();
        updatePreviewImage();
        hideError('pool-cfg-err-modelos');
        scheduleSave();
      });
    });

    $all('.pool-cfg-vinil-card').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.vinilHandle = btn.getAttribute('data-vinil-handle') || '';
        state.vinilTitulo = btn.getAttribute('data-vinil-title') || '';
        state.vinilImagemUrl = btn.getAttribute('data-vinil-image') || '';
        state.vinilProductUrl = btn.getAttribute('data-vinil-url') || '';
        var pg = btn.getAttribute('data-vinil-page');
        if (pg !== null && pg !== '') vinilCarouselPage = parseInt(pg, 10) || 0;
        syncSelectionClasses();
        renderSummary();
        updateVinylLayer();
        hideError('pool-cfg-err-vinil');
        scheduleSave();
      });
    });

    var vinilStep = document.getElementById('pool-step-vinil');
    if (vinilStep) {
      vinilStep.addEventListener('click', function (e) {
        var nav = e.target.closest('[data-vinil-nav]');
        if (!nav) return;
        e.preventDefault();
        e.stopPropagation();
        var dir = nav.getAttribute('data-vinil-nav');
        var cards = getVinilCards();
        var totalPages = Math.max(1, Math.ceil(cards.length / VINIL_PAGE_SIZE));
        if (cards.length <= VINIL_PAGE_SIZE) return;
        if (dir === 'prev') vinilCarouselPage--;
        else if (dir === 'next') vinilCarouselPage++;
        if (vinilCarouselPage < 0) vinilCarouselPage = 0;
        if (vinilCarouselPage > totalPages - 1) vinilCarouselPage = totalPages - 1;
        renderVinilCarousel();
      });
    }

    $all('#pool-cfg-medida-largura, #pool-cfg-medida-comprimento, #pool-cfg-medida-obs').forEach(function (el) {
      el.addEventListener('input', function () {
        readMedidasFields();
        renderSummary();
        scheduleSave();
      });
      el.addEventListener('change', function () {
        readMedidasFields();
        renderSummary();
        scheduleSave();
      });
    });

    $all('[data-adicional]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        collectAdicionaisFromDom();
        renderSummary();
        scheduleSave();
      });
    });

    var desc = document.getElementById('pool-cfg-descricao');
    if (desc)
      desc.addEventListener('input', function () {
        updateDescCounter();
        readPersonalFields();
        scheduleSave();
      });

    $all(
      '#pool-cfg-formato, #pool-cfg-largura, #pool-cfg-comprimento, #pool-cfg-estilo, #pool-cfg-referencia'
    ).forEach(function (el) {
      el.addEventListener('input', function () {
        readPersonalFields();
        scheduleSave();
      });
      el.addEventListener('change', function () {
        readPersonalFields();
        scheduleSave();
      });
    });

    $all('#pool-cfg-nome, #pool-cfg-telefone, #pool-cfg-email').forEach(function (el) {
      el.addEventListener('input', function () {
        readContactFields();
        scheduleSave();
      });
    });

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;
      var backBtn = t.closest('[data-action="back"]');
      if (backBtn) {
        e.preventDefault();
        back();
        return;
      }
      var nextBtn = t.closest('[data-action]');
      if (!nextBtn) return;
      var act = nextBtn.getAttribute('data-action');
      if (act && act.indexOf('next-') === 0 && act !== 'next-dados') {
        next();
      }
    });

    var waBtn = document.getElementById('pool-cfg-btn-wa');
    if (waBtn) {
      waBtn.addEventListener('click', function () {
        openWhatsApp();
      });
    }
  }

  function init() {
    if (!getRoot()) return;
    loadAssets();
    var img = document.getElementById('pool-cfg-preview-img');
    if (img && img.src) defaultPreviewSrc = toAbsoluteAssetUrl(img.src);
    hydrate();
    bind();
    syncFormFieldsFromState();
    collectAdicionaisFromDom();
    renderAll();
    persist();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
